import { EnvironmentService } from './environment.service';

/** APP_INITIALIZER factory — loads optional runtime JSON before first paint. */
export function runtimeConfigInitializer(env: EnvironmentService): () => Promise<void> {
  return () => env.loadRuntimeConfig();
}
